import Model from './Model'

export default class ResourceVideoAttachment extends Model {
  resource() {
    return 'attachments'
  }
}
